export default "__VITE_ASSET__DbXyb72O__"